import { SkeletonBox } from '@billy/design-system'
import { ReactElement } from 'react'

import { useFetchZervantSubscription } from '@features/zervant-subscription/hooks/useFetchZervantSubscription'
import { useOpenZervantPortal } from '@features/zervant-subscription/hooks/useOpenZervantPortal'

import { StripePortalInvoicesSection } from './elements/StripePortalInvoicesSection'
import { StripePortalPaymentSection } from './elements/StripePortalPaymentSection'
import { StripePortalPlanSection } from './elements/StripePortalPlanSection'

const PORTAL_FLOW = {
  SUBSCRIPTION_UPDATE: 'subscription_update',
  PAYMENT_METHOD_UPDATE: 'payment_method_update',
  INVOICE_HISTORY: 'invoice_history',
} as const

interface StripePortalSubscriptionProps {
  isLoading: boolean
}

export const StripePortalSubscription = ({ isLoading }: StripePortalSubscriptionProps): ReactElement => {
  const { openPortal, isLoading: isOpeningPortal } = useOpenZervantPortal()
  const { zervantSubscription, isLoading: isSubscriptionLoading } = useFetchZervantSubscription()

  if (isLoading || isSubscriptionLoading) {
    return <SkeletonBox height={240} fullWidth />
  }

  return (
    <>
      <StripePortalPlanSection
        zervantSubscription={zervantSubscription}
        isOpeningPortal={isOpeningPortal}
        onChangePlan={() => openPortal(PORTAL_FLOW.SUBSCRIPTION_UPDATE)}
      />
      <StripePortalPaymentSection
        zervantSubscription={zervantSubscription}
        isOpeningPortal={isOpeningPortal}
        onChangePayment={() => openPortal(PORTAL_FLOW.PAYMENT_METHOD_UPDATE)}
      />
      <StripePortalInvoicesSection
        isOpeningPortal={isOpeningPortal}
        onViewInvoices={() => openPortal(PORTAL_FLOW.INVOICE_HISTORY)}
      />
    </>
  )
}
